export default "__VITE_ASSET__CQptM8Sc__"